import React from 'react';
import { Drawer, Box, Typography, IconButton, MenuItem } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import Iconify from '../../../components/Iconify';
import Image from '../../../components/Image';
import useLocales from '../../../hooks/useLocales';
import { isSafariOrIOS } from '../../../utils/isSafariOrIOS';

export default function MobileLanguageDrawer({ open, onClose, languages = [], currentLang, onSelectLang }) {
  const { translate } = useLocales();
  const theme = useTheme();
  const handleChangeLang = (lang) => {
    localStorage.setItem('i18nextLng', lang);
    onSelectLang(lang);
    onClose();
  };

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={onClose}
      PaperProps={{
        sx: {
          width: '100%',
        },
      }}
    >
      <Box sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
        <IconButton onClick={onClose} sx={{ position: 'absolute', left: 8 }}>
          <Iconify icon="material-symbols:arrow-back-ios-new-rounded" />
        </IconButton>
        <Typography variant="h6" fontWeight={700}>
          {translate('language')}
        </Typography>
      </Box>

      {/* Language List */}
      <Box
        sx={{
          p: 2,
          background: isSafariOrIOS ? theme.palette.gradients.theme3Ios : theme.palette.gradients.theme3,
          flex: 1,
        }}
      >
        {languages.map((option) => {
          const isSelected = option.value === currentLang?.value;

          return (
            <MenuItem
              key={option.value}
              onClick={() => handleChangeLang(option.value)}
              sx={{
                background: isSelected ? (theme) => theme.palette.gradients.buttonPrimary : '#fff',
                borderRadius: 1,
                mb: 1,
                height: '64px',
              }}
            >
              <Image src={option.icon} sx={{ width: 28, height: 20, mr: 2 }} />
              <Typography sx={{ fontWeight: 600 }}>{option.label}</Typography>
            </MenuItem>
          );
        })}
      </Box>
    </Drawer>
  );
}
